import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import TryItButton from "../../../TryItButton";
import OutputBox from "../../../OutputBox";

export default function JS_NestedTernary() {
  return (
    <div className="tutorial-container read-only">
      <h1 className="tutorial-title">🟤 JavaScript Nested Ternary Operator</h1>

      {/* 🔹 Explanation */}
      <div className="tutorial-section">
        <h2 className="section-title">💡 What is a Nested Ternary?</h2>
        <p>
          A <b>Nested Ternary Operator</b> is when you place one ternary inside
          another. It's useful for evaluating multiple conditions inline,
          instead of using lengthy if...else if...else chains.
        </p>
        <p>
          Syntax:{" "}
          <code className="highlight_code">
            condition1 ? value1 : condition2 ? value2 : value3
          </code>
        </p>
        <p>
          Use it carefully, because readability can decrease if overused. At{" "}
          <b>Edu-Tech Master Academy</b>, it's great for small, multi-level
          checks.
        </p>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ Exam Grade</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let score = 85;
let grade = score >= 90 ? "A - Excellent" :
            score >= 75 ? "B - Good" :
            score >= 50 ? "C - Pass" :
            "F - Fail";
console.log("Edu-Tech Master Academy Grade:", grade);`}
          />
          <TryItButton
            code={`let score = 85;
let grade = score >= 90 ? "A - Excellent" :
            score >= 75 ? "B - Good" :
            score >= 50 ? "C - Pass" :
            "F - Fail";
console.log("Edu-Tech Master Academy Grade:", grade);`}
          />
        </div>
        <OutputBox>
          <pre>Edu-Tech Master Academy Grade: B - Good</pre>
        </OutputBox>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ Subscription Plan</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let plan = "basic";
let access = plan === "premium" ? "All courses unlocked" :
            plan === "standard" ? "Most courses unlocked" :
            "Limited access";
console.log("Edu-Tech Master Academy Access:", access);`}
          />
          <TryItButton
            code={`let plan = "basic";
let access = plan === "premium" ? "All courses unlocked" :
            plan === "standard" ? "Most courses unlocked" :
            "Limited access";
console.log("Edu-Tech Master Academy Access:", access);`}
          />
        </div>
        <OutputBox>
          <pre>Edu-Tech Master Academy Access: Limited access</pre>
        </OutputBox>
      </div>

      {/* Example 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">3️⃣ Attendance Check</h2>
        <div className="code-demo-box read-only-box">
          <CodeCopyBlock
            code={`let attendance = 82;
let status = attendance >= 90 ? "Excellent" :
             attendance >= 75 ? "Good" :
             attendance >= 50 ? "Average" :
             "Poor";
console.log("Edu-Tech Master Academy Attendance Status:", status);`}
          />
          <TryItButton
            code={`let attendance = 82;
let status = attendance >= 90 ? "Excellent" :
             attendance >= 75 ? "Good" :
             attendance >= 50 ? "Average" :
             "Poor";
console.log("Edu-Tech Master Academy Attendance Status:", status);`}
          />
        </div>
        <OutputBox>
          <pre>Edu-Tech Master Academy Attendance Status: Good</pre>
        </OutputBox>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #e9d5ff, #d8b4fe)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#6b21a8" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Practice nested ternaries for small, inline multi-condition checks.
          </li>
          <li>
            Compare readability against if...else if...else for complex cases.
          </li>
          <li>Use nested ternaries in JSX for dynamic content rendering.</li>
          <li>Avoid deep nesting to keep code maintainable.</li>
        </ul>
      </div>
    </div>
  );
}
